import React, { useState, useMemo, useEffect, useRef } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Link,
  Typography,
  IconButton,
  Popover,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  CircularProgress,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { API_URL } from './constants';
// Future: DatePicker mirror selector
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
// import { parseISO, isEqual, format } from 'date-fns';

const COUNTRY_OPTIONS = [
  { value: 'italy', label: 'Italy', disabled: false },
  { value: 'romania', label: 'Romania', disabled: false },
  { value: 'poland', label: 'Poland', disabled: false },
  { value: 'uk', label: 'United Kingdom', disabled: false },
  { value: 'czechia', label: 'Czechia', disabled: false },
];

/** Temporarily IQOS only; add Glo back to the array when needed. */
const WEBSITE_OPTIONS = [{ value: 'iqos', label: 'IQOS' }];

const DATE_OPTIONS = [
  {
    value: '2026-01-16',
    label: '2026-01-16 (Italy)',
    port: 9003,
    protocol: 'https:',
    country: 'italy',
    dateParam: '20260116-120411',
  },
  {
    value: '2026-02-27',
    label: '2026-02-27 (Italy)',
    port: 9004,
    protocol: 'https:',
    country: 'italy',
    dateParam: '20260227-150147',
  },
  {
    value: '2026-03-13',
    label: '2026-03-13 (Italy)',
    port: 8006,
    country: 'italy',
    dateParam: '20260313-102105',
    disabled: true,
  },
  {
    value: '2026-03-03',
    label: '2026-03-03 (Romania)',
    port: 9201,
    country: 'romania',
    dateParam: '20260303-092124',
    protocol: 'https:',
  },
  {
    value: '2026-05-04',
    label: '2026-05-04 (Italy)',
    port: 9008,
    country: 'italy',
    dateParam: '20260504-121729',
    protocol: 'https:',
    disabled: true,
  },
  {
    value: '2026-06-22',
    label: '2026-06-22 (Poland)',
    port: 9103,
    country: 'poland',
    dateParam: '20260622',
    protocol: 'https:',
  },
  {
    value: '2026-06-22',
    label: '2026-06-22 (Romania)',
    port: 9203,
    country: 'romania',
    dateParam: '20260622',
    protocol: 'https:',
  },
  {
    value: '2026-06-22',
    label: '2026-06-22 (United Kingdom)',
    port: 9303,
    country: 'uk',
    dateParam: '20260622',
    protocol: 'https:',
  },
  {
    value: '2026-06-22',
    label: '2026-06-22 (Italy)',
    port: 9403,
    country: 'italy',
    dateParam: '20260622',
    protocol: 'https:',
  },
  {
    value: '2026-07-06',
    label: '2026-07-06 (Poland)',
    port: 9104,
    country: 'poland',
    dateParam: '20260706-060009',
    protocol: 'https:',
  },
  {
    value: '2026-07-06',
    label: '2026-07-06 (Romania)',
    port: 9204,
    country: 'romania',
    dateParam: '20260706-060009',
    protocol: 'https:',
  },
  {
    value: '2026-07-06',
    label: '2026-07-06 (United Kingdom)',
    port: 9304,
    country: 'uk',
    dateParam: '20260706-060009',
    protocol: 'https:',
  },
  {
    value: '2026-07-06',
    label: '2026-07-06 (Italy)',
    port: 9404,
    country: 'italy',
    dateParam: '20260706-060009',
    protocol: 'https:',
  },
  {
    value: '2026-07-06',
    label: '2026-07-06 (Czechia)',
    port: 9504,
    country: 'czechia',
    dateParam: '20260706-060009',
    protocol: 'https:',
  },
  {
    value: '2026-07-13',
    label: '2026-07-13 (Poland)',
    port: 9105,
    country: 'poland',
    dateParam: '20260713-061018',
    protocol: 'https:',
  },
  {
    value: '2026-07-13',
    label: '2026-07-13 (Romania)',
    port: 9205,
    country: 'romania',
    dateParam: '20260713-060007',
    protocol: 'https:',
  },
  {
    value: '2026-07-13',
    label: '2026-07-13 (United Kingdom)',
    port: 9305,
    country: 'uk',
    dateParam: '20260713-061008',
    protocol: 'https:',
  },
  {
    value: '2026-07-13',
    label: '2026-07-13 (Italy)',
    port: 9405,
    country: 'italy',
    dateParam: '20260713-060007',
    protocol: 'https:',
  },
  {
    value: '2026-07-13',
    label: '2026-07-13 (Czechia)',
    port: 9505,
    country: 'czechia',
    dateParam: '20260713-060624',
    protocol: 'https:',
  },
  {
    value: '2026-07-20',
    label: '2026-07-20 (Poland)',
    port: 9106,
    country: 'poland',
    dateParam: '20260720',
    protocol: 'https:',
  },
  {
    value: '2026-07-20',
    label: '2026-07-20 (Romania)',
    port: 9206,
    country: 'romania',
    dateParam: '20260720',
    protocol: 'https:',
  },
  {
    value: '2026-07-20',
    label: '2026-07-20 (United Kingdom)',
    port: 9306,
    country: 'uk',
    dateParam: '20260720',
    protocol: 'https:',
  },
  {
    value: '2026-07-20',
    label: '2026-07-20 (Italy)',
    port: 9406,
    country: 'italy',
    dateParam: '20260720',
    protocol: 'https:',
  },
  {
    value: '2026-07-20',
    label: '2026-07-20 (Czechia)',
    port: 9506,
    country: 'czechia',
    dateParam: '20260720',
    protocol: 'https:',
  },
  {
    value: '2026-07-27',
    label: '2026-07-27 (Poland)',
    port: 9107,
    country: 'poland',
    dateParam: '20260727',
    protocol: 'https:',
  },
  {
    value: '2026-07-27',
    label: '2026-07-27 (Romania)',
    port: 9207,
    country: 'romania',
    dateParam: '20260727',
    protocol: 'https:',
  },
  {
    value: '2026-07-27',
    label: '2026-07-27 (United Kingdom)',
    port: 9307,
    country: 'uk',
    dateParam: '20260727',
    protocol: 'https:',
  },
  {
    value: '2026-07-27',
    label: '2026-07-27 (Italy)',
    port: 9407,
    country: 'italy',
    dateParam: '20260727',
    protocol: 'https:',
  },
  {
    value: '2026-07-27',
    label: '2026-07-27 (Czechia)',
    port: 9507,
    country: 'czechia',
    dateParam: '20260727',
    protocol: 'https:',
  },
  {
    value: '2026-08-03',
    label: '2026-08-03 (Poland)',
    port: 9108,
    country: 'poland',
    dateParam: '20260803',
    protocol: 'https:',
  },
  {
    value: '2026-08-03',
    label: '2026-08-03 (Romania)',
    port: 9208,
    country: 'romania',
    dateParam: '20260803',
    protocol: 'https:',
  },
  {
    value: '2026-08-03',
    label: '2026-08-03 (United Kingdom)',
    port: 9308,
    country: 'uk',
    dateParam: '20260803',
    protocol: 'https:',
  },
  {
    value: '2026-08-03',
    label: '2026-08-03 (Italy)',
    port: 9408,
    country: 'italy',
    dateParam: '20260803',
    protocol: 'https:',
  },
  {
    value: '2026-08-03',
    label: '2026-08-03 (Czechia)',
    port: 9508,
    country: 'czechia',
    dateParam: '20260803',
    protocol: 'https:',
  },
  {
    value: '2026-08-10',
    label: '2026-08-10 (Poland)',
    port: 9109,
    country: 'poland',
    dateParam: '20260810',
    protocol: 'https:',
  },
  {
    value: '2026-08-10',
    label: '2026-08-10 (Romania)',
    port: 9209,
    country: 'romania',
    dateParam: '20260810',
    protocol: 'https:',
  },
  {
    value: '2026-08-10',
    label: '2026-08-10 (United Kingdom)',
    port: 9309,
    country: 'uk',
    dateParam: '20260810',
    protocol: 'https:',
  },
  {
    value: '2026-08-10',
    label: '2026-08-10 (Italy)',
    port: 9409,
    country: 'italy',
    dateParam: '20260810',
    protocol: 'https:',
  },
  {
    value: '2026-08-10',
    label: '2026-08-10 (Czechia)',
    port: 9509,
    country: 'czechia',
    dateParam: '20260810',
    protocol: 'https:',
  },
  {
    value: '2026-08-17',
    label: '2026-08-17 (Poland)',
    port: 9110,
    country: 'poland',
    dateParam: '20260817',
    protocol: 'https:',
  },
  {
    value: '2026-08-17',
    label: '2026-08-17 (Romania)',
    port: 9210,
    country: 'romania',
    dateParam: '20260817',
    protocol: 'https:',
  },
  {
    value: '2026-08-17',
    label: '2026-08-17 (United Kingdom)',
    port: 9310,
    country: 'uk',
    dateParam: '20260817',
    protocol: 'https:',
  },
  {
    value: '2026-08-17',
    label: '2026-08-17 (Italy)',
    port: 9410,
    country: 'italy',
    dateParam: '20260817',
    protocol: 'https:',
  },
  {
    value: '2026-08-17',
    label: '2026-08-17 (Czechia)',
    port: 9510,
    country: 'czechia',
    dateParam: '20260817',
    protocol: 'https:',
  },
  {
    value: '2026-10-12',
    label: '2026-10-12 (Poland)',
    port: 9118,
    country: 'poland',
    dateParam: '20261012',
    protocol: 'https:',
  },
  {
    value: '2026-10-12',
    label: '2026-10-12 (Romania)',
    port: 9218,
    country: 'romania',
    dateParam: '20261012',
    protocol: 'https:',
  },
  {
    value: '2026-10-12',
    label: '2026-10-12 (United Kingdom)',
    port: 9318,
    country: 'uk',
    dateParam: '20261012',
    protocol: 'https:',
  },
  {
    value: '2026-10-12',
    label: '2026-10-12 (Italy)',
    port: 9418,
    country: 'italy',
    dateParam: '20261012',
    protocol: 'https:',
  },
  {
    value: '2026-10-12',
    label: '2026-10-12 (Czechia)',
    port: 9518,
    country: 'czechia',
    dateParam: '20261012',
    protocol: 'https:',
  },
];

const DEFAULT_DATE = '2026-10-12';
const DEFAULT_COUNTRY = 'italy';

/** Default when a date option has no `protocol`; HTTP avoids SSL_ERROR_RX_RECORD_TOO_LONG on plain-HTTP backends. */
const MIRROR_APP_PROTOCOL = 'http:';

const AVAILABLE_MIRROR_DATES = DATE_OPTIONS.filter((opt) => !opt.disabled);

const LATEST_MIRROR_DATE = AVAILABLE_MIRROR_DATES
  .map((o) => o.value)
  .sort((a, b) => b.localeCompare(a))[0];

const MIRROR_PROBE_TIMEOUT_MS = 4000;

function mirrorBaseUrl(option) {
  const protocol = option?.protocol || MIRROR_APP_PROTOCOL;
  const port = option?.port || 8002;
  return `${protocol}//app.forloop.ai:${port}`;
}

/** Connectivity probe (no-cors): resolves true if the host responds, false on timeout/network error. */
async function probeMirrorAvailability(option) {
  if (!option?.port) return false;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), MIRROR_PROBE_TIMEOUT_MS);
  try {
    await fetch(`${mirrorBaseUrl(option)}/`, {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-store',
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

function newestMirrorForCountry(country, options) {
  return options
    .filter((o) => o.country === country)
    .sort((a, b) => b.value.localeCompare(a.value))[0];
}

const FALLBACK_SCREENSHOT_MIRRORS = [
  { folder: 'iqos_cz_20260908', website: 'iqos', country: 'czechia', date: '2026-09-08' },
];

function newestScreenshotForCountry(country, mirrors) {
  return mirrors
    .filter((m) => m.country === country)
    .sort((a, b) => b.date.localeCompare(a.date))[0];
}

function formatScreenshotGroupLabel(group) {
  if (!group) return 'Pages';
  return group.replace(/[_-]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

function ScreenshotMirrorViewer({ folder, pages, selectedPath, onSelectPath, loading, error }) {
  const imageContainerRef = useRef(null);

  useEffect(() => {
    imageContainerRef.current?.scrollTo(0, 0);
  }, [selectedPath]);

  const grouped = useMemo(() => {
    const order = [];
    const byGroup = new Map();
    pages.forEach((page) => {
      const key = page.group || '';
      if (!byGroup.has(key)) {
        byGroup.set(key, []);
        order.push(key);
      }
      byGroup.get(key).push(page);
    });
    return order.map((key) => ({
      key,
      label: formatScreenshotGroupLabel(key),
      pages: byGroup.get(key),
    }));
  }, [pages]);

  const selectedLabel = pages.find((page) => page.path === selectedPath)?.label || 'Screenshot';
  const imageSrc =
    folder && selectedPath
      ? encodeURI(`${API_URL}/iqos-image-mirrors/${folder}/${selectedPath}`)
      : null;

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex' }}>
      <Paper
        elevation={0}
        sx={{
          width: 260,
          flexShrink: 0,
          borderRight: '1px solid',
          borderColor: 'divider',
          overflow: 'auto',
          borderRadius: 0,
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error" sx={{ p: 2 }}>
            {error}
          </Typography>
        ) : pages.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
            No screenshots available for this country and date.
          </Typography>
        ) : (
          grouped.map((group) => (
            <List
              key={group.key || 'pages'}
              dense
              subheader={
                <ListSubheader sx={{ bgcolor: 'background.paper', lineHeight: '36px' }}>
                  {group.label}
                </ListSubheader>
              }
            >
              {group.pages.map((page) => (
                <ListItemButton
                  key={page.path}
                  selected={page.path === selectedPath}
                  onClick={() => onSelectPath(page.path)}
                >
                  <ListItemText primary={page.label} primaryTypographyProps={{ variant: 'body2' }} />
                </ListItemButton>
              ))}
            </List>
          ))
        )}
      </Paper>
      <Box ref={imageContainerRef} sx={{ flex: 1, minWidth: 0, overflow: 'auto', bgcolor: 'grey.100' }}>
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={selectedLabel}
            style={{ display: 'block', width: '100%', height: 'auto' }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ p: 3 }}>
            Select a page to view its screenshot.
          </Typography>
        )}
      </Box>
    </Box>
  );
}

/**
 * Mirror websites: embeds app.forloop.ai HTML mirrors, or screenshot captures
 * served from the insights API (`iqos_website/image_mirrors`).
 * Used as a subpage in the JTI Global sidebar.
 * HTML mode defaults to the latest mirror date; the date selector lives behind the settings icon.
 * Filter values are passed as URL query params so the embedded app can read them.
 * Latest HTML mirrors (2026-10-12): Poland :9118, Romania :9218, United Kingdom :9318, Italy :9418, Czechia :9518 (HTTPS).
 * Previous (2026-08-17): Poland :9110, Romania :9210, United Kingdom :9310, Italy :9410, Czechia :9510 (HTTPS).
 * If a latest mirror port is not reachable yet, the UI falls back to the previous snapshot for that country.
 * Screenshot mode currently has Czechia 2026-09-08 (`iqos_cz_20260908`).
 */

/* Future: DatePicker helpers (use with LocalizationProvider + DatePicker below)
const enabledDateObjects = DATE_OPTIONS
  .filter(opt => !opt.disabled)
  .map(opt => parseISO(opt.value));
const minEnabledDate = enabledDateObjects.reduce((a, b) => (a < b ? a : b));
const maxEnabledDate = enabledDateObjects.reduce((a, b) => (a > b ? a : b));
*/

const EmbeddedAppView = () => {
  const [selectedDate, setSelectedDate] = useState(() => {
    // Latest batch starts as unavailable; open on the previous snapshot for the default country.
    return (
      newestMirrorForCountry(
        DEFAULT_COUNTRY,
        AVAILABLE_MIRROR_DATES.filter((o) => o.value !== LATEST_MIRROR_DATE)
      )?.value || DEFAULT_DATE
    );
  });
  const [country, setCountry] = useState(DEFAULT_COUNTRY);
  const [website, setWebsite] = useState('iqos');
  const [viewMode, setViewMode] = useState('html');
  const [screenshotMirrors, setScreenshotMirrors] = useState(FALLBACK_SCREENSHOT_MIRRORS);
  const [screenshotDate, setScreenshotDate] = useState(FALLBACK_SCREENSHOT_MIRRORS[0].date);
  const [screenshotPages, setScreenshotPages] = useState([]);
  const [selectedScreenshotPath, setSelectedScreenshotPath] = useState(null);
  const [screenshotLoading, setScreenshotLoading] = useState(false);
  const [screenshotError, setScreenshotError] = useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  /** When true, always use the newest reachable mirror for the country (until user picks a date). */
  const [preferLatest, setPreferLatest] = useState(true);
  /** Ports known to be unreachable (e.g. newest mirrors not deployed yet). Start pessimistic on the latest batch. */
  const [unavailablePorts, setUnavailablePorts] = useState(() => {
    const latestPorts = AVAILABLE_MIRROR_DATES
      .filter((o) => o.value === LATEST_MIRROR_DATE)
      .map((o) => o.port);
    return new Set(latestPorts);
  });

  const reachableMirrorDates = useMemo(
    () => AVAILABLE_MIRROR_DATES.filter((o) => !unavailablePorts.has(o.port)),
    [unavailablePorts]
  );

  // Probe latest-batch mirrors once; keep previous snapshot until a port responds.
  useEffect(() => {
    let cancelled = false;
    const latestOptions = AVAILABLE_MIRROR_DATES.filter((o) => o.value === LATEST_MIRROR_DATE);

    (async () => {
      const results = await Promise.all(
        latestOptions.map(async (opt) => ({ port: opt.port, ok: await probeMirrorAvailability(opt) }))
      );
      if (cancelled) return;
      setUnavailablePorts((prev) => {
        const next = new Set(prev);
        results.forEach(({ port, ok }) => {
          if (ok) next.delete(port);
          else next.add(port);
        });
        return next;
      });
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(`${API_URL}/iqos-image-mirrors`);
        if (!response.ok) throw new Error('Failed to load screenshot mirrors');
        const data = await response.json();
        const mirrors = data.mirrors?.length ? data.mirrors : FALLBACK_SCREENSHOT_MIRRORS;
        if (!cancelled) setScreenshotMirrors(mirrors);
      } catch {
        if (!cancelled) setScreenshotMirrors(FALLBACK_SCREENSHOT_MIRRORS);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  /** Resolve the mirror option matching both date and country (dates can repeat across countries). */
  const activeOption = useMemo(() => {
    if (preferLatest) {
      return newestMirrorForCountry(country, reachableMirrorDates);
    }
    return (
      reachableMirrorDates.find((o) => o.value === selectedDate && o.country === country) ||
      newestMirrorForCountry(country, reachableMirrorDates)
    );
  }, [preferLatest, selectedDate, country, reachableMirrorDates]);

  // Keep selectedDate in sync with the active (reachable) mirror.
  useEffect(() => {
    if (!activeOption) return;
    if (activeOption.value !== selectedDate) {
      setSelectedDate(activeOption.value);
    }
  }, [activeOption, selectedDate]);

  /** Mirror dates available for the currently selected country, newest first. */
  const datesForCountry = useMemo(
    () =>
      reachableMirrorDates
        .filter((o) => o.country === country)
        .sort((a, b) => b.value.localeCompare(a.value)),
    [country, reachableMirrorDates]
  );

  const screenshotCountries = useMemo(
    () => new Set(screenshotMirrors.map((m) => m.country)),
    [screenshotMirrors]
  );

  const screenshotDatesForCountry = useMemo(
    () =>
      screenshotMirrors
        .filter((m) => m.country === country)
        .sort((a, b) => b.date.localeCompare(a.date)),
    [screenshotMirrors, country]
  );

  const activeScreenshotMirror = useMemo(() => {
    return (
      screenshotMirrors.find((m) => m.country === country && m.date === screenshotDate) ||
      newestScreenshotForCountry(country, screenshotMirrors) ||
      null
    );
  }, [screenshotMirrors, country, screenshotDate]);

  useEffect(() => {
    if (activeScreenshotMirror && activeScreenshotMirror.date !== screenshotDate) {
      setScreenshotDate(activeScreenshotMirror.date);
    }
  }, [activeScreenshotMirror, screenshotDate]);

  useEffect(() => {
    const folder = activeScreenshotMirror?.folder;
    if (viewMode !== 'screenshot' || !folder) return undefined;
    let cancelled = false;
    setScreenshotLoading(true);
    setScreenshotError(null);
    (async () => {
      try {
        const response = await fetch(`${API_URL}/iqos-image-mirrors/${encodeURIComponent(folder)}`);
        if (!response.ok) throw new Error('Failed to load screenshot pages');
        const data = await response.json();
        if (cancelled) return;
        const pages = data.pages || [];
        setScreenshotPages(pages);
        setSelectedScreenshotPath((prev) =>
          pages.some((page) => page.path === prev) ? prev : pages[0]?.path || null
        );
      } catch {
        if (!cancelled) {
          setScreenshotPages([]);
          setSelectedScreenshotPath(null);
          setScreenshotError('Could not load screenshots.');
        }
      } finally {
        if (!cancelled) setScreenshotLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [activeScreenshotMirror?.folder, viewMode]);

  const handleDateChange = (newDate) => {
    setPreferLatest(false);
    setSelectedDate(newDate);
  };

  const handleScreenshotDateChange = (newDate) => {
    setScreenshotDate(newDate);
  };

  const handleCountryChange = (newCountry) => {
    setCountry(newCountry);
    setPreferLatest(true);
    const opt = newestMirrorForCountry(newCountry, reachableMirrorDates);
    if (opt) setSelectedDate(opt.value);
    const shot = newestScreenshotForCountry(newCountry, screenshotMirrors);
    if (shot) setScreenshotDate(shot.date);
  };

  const handleViewModeChange = (_, value) => {
    if (!value) return;
    setViewMode(value);
    if (value === 'screenshot' && !screenshotCountries.has(country)) {
      const fallbackCountry =
        newestScreenshotForCountry('czechia', screenshotMirrors)?.country ||
        screenshotMirrors[0]?.country;
      if (fallbackCountry) {
        setCountry(fallbackCountry);
        const shot = newestScreenshotForCountry(fallbackCountry, screenshotMirrors);
        if (shot) setScreenshotDate(shot.date);
      }
    }
  };

  const baseUrl = useMemo(() => mirrorBaseUrl(activeOption), [activeOption]);

  const iframeSrc = useMemo(() => {
    const dateForQuery = activeOption?.dateParam ?? selectedDate;
    const params = new URLSearchParams();
    params.set('date', dateForQuery);
    if (country) params.set('country', country);
    if (website) params.set('website', website);
    return `${baseUrl}?${params.toString()}`;
  }, [baseUrl, activeOption, selectedDate, country, website]);

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 56px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 2,
          p: 1.5,
          borderRadius: 0,
          borderBottom: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper'
        }}
      >
        {/*
        Future: calendar DatePicker (re-enable date-fns + MUI picker imports above, and enabledDateObjects helpers)
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date"
            value={parseISO(selectedDate)}
            onChange={(newDate) => {
              if (newDate) setSelectedDate(format(newDate, 'yyyy-MM-dd'));
            }}
            minDate={minEnabledDate}
            maxDate={maxEnabledDate}
            shouldDisableDate={(date) =>
              !enabledDateObjects.some((d) => isEqual(d, date))
            }
            slotProps={{
              textField: { size: 'small', sx: { minWidth: 160 } },
            }}
          />
        </LocalizationProvider>
        */}
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel id="embedded-app-country-label">Country</InputLabel>
          <Select
            labelId="embedded-app-country-label"
            id="embedded-app-country"
            value={country}
            label="Country"
            onChange={(e) => handleCountryChange(e.target.value)}
          >
            {COUNTRY_OPTIONS.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                disabled={opt.disabled || (viewMode === 'screenshot' && !screenshotCountries.has(opt.value))}
              >
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="embedded-app-website-label">Website</InputLabel>
          <Select
            labelId="embedded-app-website-label"
            id="embedded-app-website"
            value={website}
            label="Website"
            onChange={(e) => setWebsite(e.target.value)}
          >
            {WEBSITE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <ToggleButtonGroup
          exclusive
          size="small"
          color="primary"
          value={viewMode}
          onChange={handleViewModeChange}
          aria-label="mirror view mode"
        >
          <ToggleButton value="html" sx={{ textTransform: 'none', px: 1.5 }}>
            HTML
          </ToggleButton>
          <ToggleButton value="screenshot" sx={{ textTransform: 'none', px: 1.5 }}>
            Screenshot
          </ToggleButton>
        </ToggleButtonGroup>
        {viewMode === 'html' && (() => {
          const port = activeOption?.port;
          if (!port) return null;
          const protocol = activeOption?.protocol || MIRROR_APP_PROTOCOL;
          const mirrorUrl = `${protocol}//app.forloop.ai:${port}`;
          return (
            <Typography variant="body2" sx={{ color: 'text.secondary', ml: 1 }}>
              Mirror website is available also on{' '}
              <Link href={mirrorUrl} target="_blank" rel="noopener noreferrer">
                app.forloop.ai:{port}
              </Link>
            </Typography>
          );
        })()}
        <Tooltip title={viewMode === 'screenshot' ? 'Screenshot date settings' : 'Mirror date settings'}>
          <IconButton
            size="small"
            aria-label="mirror date settings"
            onClick={(e) => setSettingsAnchorEl(e.currentTarget)}
            sx={{ ml: 'auto' }}
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Popover
          open={Boolean(settingsAnchorEl)}
          anchorEl={settingsAnchorEl}
          onClose={() => setSettingsAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box sx={{ p: 2, minWidth: 240 }}>
            {viewMode === 'screenshot' ? (
              <FormControl size="small" fullWidth>
                <InputLabel id="embedded-app-screenshot-date-label">Screenshot date</InputLabel>
                <Select
                  labelId="embedded-app-screenshot-date-label"
                  id="embedded-app-screenshot-date"
                  value={screenshotDatesForCountry.some((opt) => opt.date === screenshotDate) ? screenshotDate : ''}
                  label="Screenshot date"
                  onChange={(e) => handleScreenshotDateChange(e.target.value)}
                  disabled={screenshotDatesForCountry.length === 0}
                >
                  {screenshotDatesForCountry.map((opt) => (
                    <MenuItem key={`${opt.folder}`} value={opt.date}>
                      {opt.date}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <FormControl size="small" fullWidth>
                <InputLabel id="embedded-app-mirror-date-label">Mirror date</InputLabel>
                <Select
                  labelId="embedded-app-mirror-date-label"
                  id="embedded-app-mirror-date"
                  value={selectedDate}
                  label="Mirror date"
                  onChange={(e) => handleDateChange(e.target.value)}
                >
                  {datesForCountry.map((opt) => (
                    <MenuItem key={`${opt.country}-${opt.value}`} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
        </Popover>
      </Paper>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex' }}>
        {viewMode === 'screenshot' ? (
          <ScreenshotMirrorViewer
            folder={activeScreenshotMirror?.folder}
            pages={screenshotPages}
            selectedPath={selectedScreenshotPath}
            onSelectPath={setSelectedScreenshotPath}
            loading={screenshotLoading}
            error={screenshotError}
          />
        ) : (
          <iframe
            title="Mirror websites"
            src={iframeSrc}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block'
            }}
            allowFullScreen
          />
        )}
      </Box>
    </Box>
  );
};

export default EmbeddedAppView;
